export default "__VITE_ASSET__DwfJtxIT__"